import {
  faCaretDown,
  faCaretUp,
  faInfoCircle,
  faLink,
  faTimesCircle,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  changeFormulaType,
  changeFormulaTypeFromDays,
  changeFormulaTypeFromGranularToRaw,
  editFormulaHerbItem,
  editSingleHerbItem,
  removeHerbFromFormula,
  removeItemFromSingleHerbList,
} from "../../actions/formulaAction";
import { getFixedDosage, getUserDetail } from "../../utils/helper";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import {
  FORMULA_HERBS_POSITION_CHANGED,
  SINGLE_HERBS_POSITION_CHANGED,
} from "../../constants/types/formulaType";
const HerbItem = ({
  rawGramPerDayBeforeConversion,
  herb,
  totalDosage,
  isLocked,
  isRawType,
  formulaId,
  isOuterLocked,
  canEditPercentage,
  isSuntenFormula = false,
  firstItem,
  lastItem,
  fromFormula = false,
  totalPacket,
}) => {
  const dispatch = useDispatch();
  const [isActive, setIsActive] = useState(false);
  const [inactiveMessage, setInactiveMessage] = useState(false);
  const [isOutOfStock, setIsOutOfStock] = useState();
  const [herbPercentange, setHerbPercentage] = useState(0);
  const role = useSelector((state) => state.role.role);
  const isAllowed = getUserDetail()?.practitioner_status == 1;
  const formulaSection = useSelector(
    (state) => state.formula.present.formulaSection
  );
  const overall = useSelector((state) => state.formula.present.overall);
  const [tempValue, setTempValue] = useState(herb.dosage.toString());
  useEffect(() => {
    setIsActive(
      isRawType
        ? !herb.rawPrice == 0 || herb.rawQuantity > 0
        : !herb.granularPrice == 0 || herb.granularQuantity > 0
    );
    setInactiveMessage(
      isRawType
        ? herb.granularQuantity > 0 && herb.granularPrice > 0
          ? "Only Available in Granular"
          : "Not Available"
        : herb.rawQuantity > 0 && herb.rawPrice > 0
        ? "Only Available in Raw"
        : "Not Available"
    );
    setIsOutOfStock(false);
  }, [isRawType]);

  const updateHerb = (dosage) => {
    dosage = isNaN(dosage) ? 0 : dosage;
    dosage = getFixedDosage(dosage);
    if (formulaId > 0) {
      if (!isRawType) {
        let newdosage = (dosage * herb.rawRatio) / herb.granularUnit;

        dispatch(changeFormulaTypeFromGranularToRaw(true, 1));
        dispatch(
          editFormulaHerbItem(
            formulaId,
            herb.id,
            newdosage,
            isLocked,
            isOuterLocked
          )
        );
        dispatch(changeFormulaTypeFromDays(false, 1));
      } else {
        dispatch(
          editFormulaHerbItem(
            formulaId,
            herb.id,
            dosage,
            isLocked,
            isOuterLocked
          )
        );
      }
    } else {
      if (!isRawType) {
        let newdosage = (dosage * herb.rawRatio) / herb.granularUnit;

        dispatch(changeFormulaTypeFromGranularToRaw(true, 1));
        dispatch(
          editSingleHerbItem(herb.id, newdosage, isLocked, isOuterLocked)
        );
        dispatch(changeFormulaTypeFromDays(false, 1));
      } else {
        dispatch(editSingleHerbItem(herb.id, dosage, isLocked, isOuterLocked));
      }
    }
  };

  const updateHerbPercentage = (dosage) => {
    if (formulaId > 0) {
      dispatch(
        editFormulaHerbItem(
          formulaId,
          herb.id,
          parseFloat(dosage),
          isLocked,
          isOuterLocked
        )
      );
    } else {
      dispatch(
        editSingleHerbItem(herb.id, parseFloat(dosage), isLocked, isOuterLocked)
      );
    }
  };

  useEffect(() => {
    setIsOutOfStock(
      isRawType
        ? herb.dosage * totalPacket > herb.rawQuantity || herb.rawQuantity == 0
        : herb.dosage > herb.granularQuantity || herb.granularQuantity == 0
    );
    setInactiveMessage(
      isRawType
        ? herb.granularQuantity > 0 && herb.granularPrice > 0
          ? "Only Available in Granular"
          : "Not Available"
        : herb.rawQuantity > 0 && herb.rawPrice > 0
        ? "Only Available in Raw"
        : "Not Available"
    );
    const percentage = herb.percentage;
    setHerbPercentage(((isNaN(percentage) ? 0 : percentage) * 100)?.toFixed(1));
    setTempValue(herb.dosage);
  }, [herb.dosage, totalDosage, formulaSection, totalPacket]);

  return (
    <>
      <tr
        className={`herb-item ${
          isActive
            ? !isOutOfStock
              ? herb.isToxic
                ? "toxic-herb"
                : ""
              : "inactive"
            : "inactive"
        } `}
      >
        <td className={`cross `}>
          {!isSuntenFormula ? (
            <div className="d-flex align-items-center">
              {rawGramPerDayBeforeConversion != null &&
              isActive &&
              !isOutOfStock &&
              !isRawType ? (
                <OverlayTrigger
                  placement="right"
                  overlay={
                    <Tooltip id="tooltip-disabled">
                      All modifications must be done in RAW. To add, delete, or
                      change dosages, please convert to Raw first, make your
                      modifications, and then convert back to granular.
                    </Tooltip>
                  }
                >
                  <span>
                    <FontAwesomeIcon
                      icon={faTimesCircle}
                      style={{
                        cursor: "not-allowed",
                        opacity: 0.5,
                      }}
                      onClick={() => {
                        // do nothing or show toast — this block is technically disabled
                      }}
                    />
                  </span>
                </OverlayTrigger>
              ) : (
                <FontAwesomeIcon
                  icon={faTimesCircle}
                  style={{
                    cursor: isRawType
                      ? "pointer"
                      : rawGramPerDayBeforeConversion != null &&
                        (!isActive || isOutOfStock)
                      ? "pointer"
                      : rawGramPerDayBeforeConversion == null
                      ? "pointer"
                      : "not-allowed",
                    opacity: isRawType
                      ? 1
                      : rawGramPerDayBeforeConversion != null &&
                        (!isActive || isOutOfStock)
                      ? 1
                      : rawGramPerDayBeforeConversion == null
                      ? 1
                      : 0.5,
                  }}
                  onClick={() => {
                    if (
                      isRawType ||
                      (!isRawType &&
                        rawGramPerDayBeforeConversion != null &&
                        (!isActive || isOutOfStock)) ||
                      (!isRawType && rawGramPerDayBeforeConversion == null)
                    ) {
                      if (formulaId > 0) {
                        if (!isRawType) {
                          dispatch(changeFormulaTypeFromGranularToRaw(true, 1));
                          dispatch(removeHerbFromFormula(formulaId, herb.id));
                          dispatch(changeFormulaTypeFromDays(false, 1));
                        } else {
                          dispatch(removeHerbFromFormula(formulaId, herb.id));
                        }
                      } else {
                        if (!isRawType) {
                          dispatch(changeFormulaTypeFromGranularToRaw(true, 1));
                          dispatch(removeItemFromSingleHerbList(herb.id));
                          dispatch(changeFormulaTypeFromDays(false, 1));
                        } else {
                          dispatch(removeItemFromSingleHerbList(herb.id));
                        }
                      }
                    }
                  }}
                />
              )}
            </div>
          ) : null}
        </td>
        <td>
          {herb.name}
          {herb.isToxic ? (
            <>
              <div
                style={{
                  marginLeft: "5px",
                  cursor: "pointer",
                  display: "inline",
                }}
              >
                <OverlayTrigger
                  placement="bottom"
                  delay={{ show: 200, hide: 100 }}
                  overlay={
                    <Tooltip id="prescription-tooltip">
                      <p style={{ textAlign: "left" }}>
                        Caution this herb may have interactions and/or toxicity.
                      </p>
                    </Tooltip>
                  }
                >
                  <FontAwesomeIcon icon={faInfoCircle} />
                </OverlayTrigger>
              </div>
            </>
          ) : (
            ""
          )}
          <br />
          {herb.allergies &&
          herb.allergies.some((x) => x.Allergy_Minimum_Gram < herb.dosage) ? (
            <OverlayTrigger
              html={true}
              style={{ minWidth: "500px" }}
              placement="right"
              delay={{ show: 200, hide: 100 }}
              overlay={
                <table className="table-allergy">
                  <thead>
                    <tr>
                      <th>Allergen Name</th>
                      <th>Minimum Quantity</th>
                    </tr>
                  </thead>
                  <tbody>
                    {herb.allergies.map((x) => (
                      <tr>
                        <td>{x.Allergy_Display}</td>
                        <td>{x.Allergy_Minimum_Gram}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              }
            >
              <p className="allergy-btn">Show Allergens</p>
            </OverlayTrigger>
          ) : (
            ""
          )}
        </td>
        {true ? (
          <td className="text-right">
            {(role.val === 4 && herb.isToxic) ||
            (!isRawType && rawGramPerDayBeforeConversion != null) ? (
              <label
                className="pr-5"
                style={{ marginBottom: 0, marginRight: "30px" }}
              >
                {parseFloat(herb.dosage).toFixed(1)}
              </label>
            ) : (
              <div className="d-flex justify-content-end pr-4 ">
                {!isRawType && (
                  <button
                    disabled
                    type="button"
                    className={`lock-btn ${isLocked ? "unhide" : "hide"}`}
                  >
                    <FontAwesomeIcon icon={faLink} />
                  </button>
                )}

                <div className="number-field">
                  <input
                    type="number"
                    min="0"
                    step="any"
                    value={tempValue}
                    onChange={(e) => setTempValue(e.target.value)}
                    onBlur={(e) => {
                      const parsedValue = parseFloat(e.target.value);
                      if (!isNaN(parsedValue)) {
                        updateHerb(parsedValue);
                      } else {
                        updateHerb(0);
                        setTempValue("0");
                      }
                    }}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        const parsedValue = parseFloat(e.target.value);
                        if (!isNaN(parsedValue)) {
                          updateHerb(parsedValue);
                        } else {
                          updateHerb(0);
                          setTempValue("0");
                        }
                      }
                    }}
                  />
                  <div>
                    <div
                      className="icon"
                      onClick={() => updateHerb(herb.dosage + 0.5)}
                    >
                      <FontAwesomeIcon icon={faCaretUp} />
                    </div>
                    <div
                      className="icon"
                      onClick={() =>
                        parseFloat(herb.dosage) > 0
                          ? updateHerb(herb.dosage - 0.5)
                          : updateHerb(0)
                      }
                    >
                      <FontAwesomeIcon icon={faCaretDown} />
                    </div>
                  </div>
                </div>
              </div>
            )}
          </td>
        ) : (
          <td className="text-right">
            <label
              className="pr-5"
              style={{ marginBottom: 0, marginRight: "30px" }}
            >
              {herb.dosage?.toFixed(1)}
            </label>
          </td>
        )}
        <td className="text-right ">
          <>{herbPercentange}% </>
        </td>
        {
          !isRawType && (
            // (herb?.rawPrice <= 0 && herb?.granularPrice <= 0 ? (
            //   <td className="text-right"></td>
            // ) : (
            <td className="text-right">
              {parseFloat(herb?.rawRatio)}
              {herb?.rawRatio && herb?.granularUnit && ":"}
              {parseFloat(herb.granularUnit)}
            </td>
          )
          // ))
        }
        {isAllowed && (
          <td className="text-right">
            {isActive
              ? !isOutOfStock
                ? role.val === 4 && herb.isToxic
                  ? "Caution"
                  : `${herb?.price?.toLocaleString("en-US", {
                      maximumFractionDigits: 2,
                      minimumFractionDigits: 2,
                      style: "currency",
                      currency: "USD",
                    })}`
                : `Only ${parseFloat(
                    isRawType ? herb?.rawQuantity : herb?.granularQuantity
                  )?.toFixed(1)} gram(s) remaining in stock`
              : inactiveMessage}
          </td>
        )}
        <td></td>
      </tr>
    </>
  );
};
export default HerbItem;
